import { GlobalFilesView } from "@/components/features/files/GlobalFilesView";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_auth/files")({
  component: GlobalFilesView,
});
